export default __webpack_public_path__ + "static/media/chat-bubble-white.144221f5.svg";